import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { SessionService } from '../../../../../@core/utils/session.service';
import { Fieldman } from '../../../models/fieldman';
import { FieldmanService } from '../../../services/Fieldman.service';
import { FieldmanListDataSource } from '../fieldman-list-datasource';

@Component({
  selector: 'fieldman-edit-list',
  templateUrl: './fieldman-edit-list.component.html',
  styleUrls: ['./fieldman-edit-list.component.scss']
})
export class FieldmanEditListComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  //#region Properties
  dataSource: FieldmanListDataSource;
  public editfieldman: Fieldman = {};
  public fieldmanId: number;
  public isLoading = false;
  public submitting: any;
  public editActive = false;
  //#endregion

  //#region ViewChild Properties
  @ViewChild(MatPaginator, { static: false }) 
  paginator: MatPaginator;

  @ViewChild(MatSort, { static: false }) 
  sort: MatSort;
  //#endregion
 
 //#region Constructor with dependencies
  constructor(
    private fieldmanService: FieldmanService,
    private errorService: ErrorService,
    public dialogRef: MatDialogRef<any>,
    private sessionService: SessionService
  ) { }
 //#endregion
  ngOnInit() {
    this.dataSource = new FieldmanListDataSource(this.paginator, this.sort);
    this.isLoading = true;
     this.editfieldman = this.sessionService.selectedFieldMan;
     if(this.editfieldman === null || this.editfieldman === undefined) {
      this.editfieldman = {};
      this.editActive = true;
      this.isLoading = false;
     }

    this.fieldmanService.getFieldmen().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:data => {
      this.dataSource.data = data;
      if(this.paginator) this.paginator._changePageSize(this.paginator.pageSize);
      this.isLoading = false;
    }, error:err => { this.errorService.handleError(err); this.isLoading = false; }});
  }

  saveFieldmanClicked() {
    // Close immediately and let FieldmanListComponent perform the actual
    // create/update in the background.
    const isNew = this.editfieldman.id === null || this.editfieldman.id === undefined;
    this.editActive = false;
    this.dialogRef.close({
      backgroundSave: true,
      isNew: isNew,
      fieldman: { ...this.editfieldman }
    });
  }

  cancelClicked(cancelled: boolean = false) {
    this.editActive = false;
    this.editfieldman = {};
    this.dialogRef.close(cancelled);
  }

}
